import React from "react";
import AppHeader from "../AppHeader/AppHeader";


const HomePage: React.FC = () => {
    return (
        <div>
            <AppHeader />
            <main>
                <h1>Welcome to the Homepage</h1>
                <p>This is the main content of the homepage.</p>
            </main>
        </div>
    );
};

export default HomePage;